module.exports = __webpack_public_path__ + "static/img/wallet.d18b1d73.svg";